"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
const index_1 = require("../index");
const ReportNode_1 = require("./ReportNode");
class WorkflowNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.WORKFLOW };
    if (props.type !== types_1.NODE_TYPES.WORKFLOW)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        waitForCompletion: false,
        targetWorkflow: "",
        options: { onlyOnData: true }
      };
    return {
      workflow: nodeData.targetWorkflow,
      waitForCompletion: nodeData.waitForCompletion,
      options: {
        onlyOnData: nodeData.options ? nodeData.options.onlyOnData : true
      }
    };
  }
  serialize(uiData) {
    return {
      targetWorkflow: uiData.workflow,
      waitForCompletion: uiData.waitForCompletion,
      options: {
        onlyOnData: uiData.options ? uiData.options.onlyOnData : true
      }
    };
  }
  getAttachedApis(selectedResource) {
    if (
      !this.workflow ||
      !selectedResource ||
      !selectedResource.context ||
      !selectedResource.context.selectedNode
    )
      return [];
    let selectedNode = this.workflow.getNodeById(
      selectedResource.context.selectedNode.selectedResourceId
    );
    let selectedRes = selectedResource.context.selectedNode;
    selectedRes.nodeRef = selectedNode;
    return selectedNode.getAttachedApis(selectedRes);
  }
  async getAvailableResources() {
    let nodeData = this.getNodeData();
    let dataResolver = this.getDataResolver();
    if (
      !nodeData ||
      !nodeData.targetWorkflow ||
      typeof nodeData.targetWorkflow !== "string" ||
      !dataResolver
    )
      return [];
    if (!this.workflow) {
      let targetWorkflowDetails = await dataResolver.resolve(
        "getWorkflowDetails",
        nodeData.targetWorkflow
      );
      if (!targetWorkflowDetails || !targetWorkflowDetails.definition)
        return [];
      this.workflow = new index_1.Workflow({
        isModelDirty: false,
        ...targetWorkflowDetails
      });
    }
    let dummyNode = new ReportNode_1.ReportNode();
    this.workflow.addNodeAtLast(dummyNode);
    let avRes = await this.workflow.getAllAvailableResources(dummyNode);
    return avRes
      .filter(x => x.label !== "NONE")
      .map(x => {
        return {
          label: nodeData ? this.getNodeName() + "." + x.label : x.label,
          selectedResourceId: this.getNodeId(),
          nodeRef: this,
          path: "",
          context: {
            outputPath: "",
            workflow: nodeData ? nodeData.targetWorkflow : "",
            selectedNode: x
          }
        };
      });
  }
  async getOutputKeys(params) {
    if (
      !this.workflow ||
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.selectedNode
    )
      return [];
    let selectedNode = this.workflow.getNodeById(
      params.resource.context.selectedNode.selectedResourceId
    );
    if (!selectedNode) return [];
    let selectedResource = params.resource.context.selectedNode;
    selectedResource.nodeRef = selectedNode;
    return selectedNode.getOutputKeys({
      resource: selectedResource,
      workflow: params.workflow
    });
  }
  validate() {
    return new validations_1.WorkflowTriggerNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.WorkflowNode = WorkflowNode;
//# sourceMappingURL=WorkflowNode.js.map
